export const couponCalloutSharedKeyMap = {
  FAC_Coupon_Banner_Title: _TL_('Limited time offer:'),
  Coupon_TermsAndConditions: _TL_('View Terms and Conditions'),
  Button_Close: _TL_('Close'),
  Button_Confirm: _TL_('Confirm'),
  Button_Cancel: _TL_('Cancel'),
  Coupon_GotIt: _TL_('Got it!'),
  Coupon_TagMessageNew: _TL_('{{value}} offer'),
  Coupon_TagFlyoutMessage: _TL_('Get {{value}} in advertising credit when you {{tagMessage}} and spend {{cost}} on your campaigns!'),
  Coupon_OfferExpirationDateMessage: _TL_('Offer expires {{expirationDate}}.'),
  Coupon_LightboxTitleNew: _TL_('Get {{value}} in advertising credit when you {{titleAction}} and spend {{cost}} on your campaigns!'),
  Coupon_LightboxStepNumberNew: _TL_('Step {{stepNumber}}:'),
  Coupon_LightboxStep3Title: _TL_('Receive your credit'),
  Coupon_LightboxStep3Description: _TL_('Spend {{cost}} on your campaigns to unlock your {{value}} in advertising credit.'),
  Coupon_LightboxStep3DescriptionNew: _TL_('Spend {{cost}} on your campaigns by {{expirationDate}}, you\'ll automatically receive {{value}} in advertising credit.'),
  Coupon_Lightbox_LimitedTimeOffer: _TL_('This is a limited-time offer. Please act soon!'),
  Coupon_Lightbox_LimitedTimeOffer_ActBy: _TL_('This is a limited offer. Act by {{expirationDate}}.'),
  GenericFACAdoptionStartErrorMessage: _TL_('Only Advertiser Campaign Managers, Super Admins, and Standard Users have permission to redeem coupons. Please use a different account or contact this account\'s administrator to adjust your user role accordingly.'),
  FACDepletedErrorMessage: _TL_('We\'re sorry, this promotion is is no longer available.'),
  Button_NotInterested: _TL_('Not interested'),
  Button_ActivateNow: _TL_('Activate now'),
  Button_RemindMeLater: _TL_('Remind me later'),
  Not_Interested_Title: _TL_('We won\'t show you this again.'),
  Not_Interested_Description: _TL_('If you change your mind, you can access this offer on the'),
  Coupon_Page: _TL_('Coupons page.'),
  RemindLater_Title: _TL_('Are you sure you want to be reminded later?'),
  RemindLater_Description_Expiration: _TL_('This offer expires in {{diffDays}} days.'),
  RemindLater_Description_Expiration_OneDay: _TL_('This offer expires in 1 day.'),
  RemindLater_Description_ActivationMessage_1: _TL_('You can'),
  RemindLater_Description_ActivationMessageLink: _TL_('activate and accept'),
  RemindLater_Description_ActivationMessage_2: _TL_('at anytime before the expiration date.'),
  Button_Confirmation: _TL_('Yes, I\'m sure'),
  Claimed_Title: _TL_('You have a coupon on your account!'),
  Claimed_ConfirmationButton: _TL_('Got it'),
  Claimed_DontShowAgain: _TL_('Don\'t show this again'),
  CloseButtonAria: _TL_('Close coupon callout'),
};

export const couponCalloutShoppingKeyMap = {
  ...couponCalloutSharedKeyMap,
  Coupon_LightboxTitleNew: _TL_('Get a {{value}} credit when you create a shopping campaign!'),
  Coupon_LightboxTitleNew_Shopping_Campaign: _TL_('Get a {{value}} credit when you create a shopping campaign!'),
  Summary_Card_Coupon_Title_Shopping_Campaign: _TL_('create a shopping campaign'),
  Summary_Card_Coupon_Description_Title_Shopping_Campaign: _TL_('create a shopping campaign'),
  Summary_Card_Coupon_Description_Shopping_Campaign: _TL_('create a shopping campaign'),
  Summary_Card_Coupon_Tag_Message_Shopping_Campaign: _TL_('create a shopping campaign'),
  Coupon_LightboxStep1Description_Shopping_Campaign: _TL_('Make sure that you have an active store in {{link}}Microsoft Merchant Center{{/link}}.'),
  Coupon_LightboxStep2Description_Shopping_Campaign: _TL_('Activate an existing shopping campaign or create a new one.'),
  Coupon_LightboxStep3Description_Shopping_Campaign: _TL_('Run an active shopping campaign for 10 days.'),
};

export const couponCalloutConversionTrackingKeyMap = {
  ...couponCalloutSharedKeyMap,
  Summary_Card_Coupon_Title_Conversion_Tracking: _TL_('set up a new website-based conversion goal'),
  Summary_Card_Coupon_Description_Title_Conversion_Tracking: _TL_('set up a new website-based conversion goal'),
  Summary_Card_Coupon_Description_Conversion_Tracking: _TL_('set up a new website-based conversion goal'),
  Summary_Card_Coupon_Tag_Message_Conversion_Tracking: _TL_('set up a new website-based conversion goal'),
  // Coupon_BannerMessageNew: _TL_('Limited time offer: Do this now and get {{value}} in advertising credit!'),
  Coupon_LightboxStep1Description: _TL_('Set up a new website-based conversion goal'),
  Coupon_LightboxStep2Description: _TL_('Keep your conversion goal and UET tag active'),
};
